import { WithBillId } from '@mews-commander/types';
import { LocalizedCurrencyValue, lt } from '@mews/framework';
import { Divider, Stack, Typography } from '@optimus-web/core';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { useBillReinstateDetails } from '../hooks';
import { useBillTotalAmount } from './useBillTotalAmount';

export const BillDetails = ({ billId }: WithBillId) => {
    const { bill } = useBillReinstateDetails({ billId });
    const totalAmount = useBillTotalAmount({ billId });

    if (!bill) return null;

    return (
        <Stack spacing="100" vertical>
            <Typography textStyle="bodyMediumStrong" as="div">
                {lt('ToBeReissued')}
            </Typography>
            <Divider />
            <Stack distribution="space-between" spacing="200">
                <Stack spacing="200">
                    <Typography textStyle="bodyLarge" as="div">
                        {bill.name}
                    </Typography>
                    <Typography textStyle="bodyLarge" as="div">
                        <LocalizedDateFromUtc utcString={bill.createdUtc} />
                    </Typography>
                </Stack>
                {totalAmount && (
                    <Typography textStyle="bodyLarge" as="div">
                        <LocalizedCurrencyValue value={totalAmount} />
                    </Typography>
                )}
            </Stack>
        </Stack>
    );
};
